import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

export const PageHeader = ({ crumbs, label, title, children }) => (
  <section className="bg-[#0A0A0A] pt-16 pb-20 border-b border-[#2E2820]">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
      <nav data-testid="breadcrumb" className="flex flex-wrap items-center gap-2 text-sm text-[#8C8578] mb-10">
        <Link to="/" className="hover:text-[#D4A537] transition-colors">Accueil</Link>
        {crumbs.map((c) => (
          <React.Fragment key={c.label}>
            <ChevronRight className="w-3 h-3" />
            {c.to ? <Link to={c.to} className="hover:text-[#D4A537] transition-colors">{c.label}</Link> : <span className="text-[#F5EFE3]">{c.label}</span>}
          </React.Fragment>
        ))}
      </nav>
      <span className="text-[#D4A537] font-semibold uppercase tracking-wider text-sm animate-fade-in">{label}</span>
      <h1 className="font-['Oswald'] text-4xl sm:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6 animate-fade-in-up">{title}</h1>
      {children}
    </div>
  </section>
);

export const CtaBand = ({ title = "Un projet sur ce type de chantier ?", text = "Contactez-nous pour un devis gratuit sous 48h." }) => (
  <section className="bg-[#141210] border-y border-[#D4A537]/30 py-16">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 flex flex-col md:flex-row md:items-center justify-between gap-8 reveal">
      <div>
        <h2 className="font-['Oswald'] text-3xl font-bold text-white mb-2">{title}</h2>
        <p className="text-[#A8A091]">{text}</p>
      </div>
      <Link to="/contact" data-testid="cta-band-devis-btn" className="btn-primary inline-flex items-center gap-2 self-start md:self-auto">
        Demander un devis <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </section>
);
